// export const PROXY_SERVER = process.env.NODE_ENV === 'development' ? 'http://192.168.200.184:7001/api' : '';
//testing http://suplbe.local/api
//live https://supplier-api.ewbholdings.com/api
export const PROXY_SERVER = process.env.NODE_ENV === 'development' ? 'http://localhost:8005/api' : 'https://supplier-api.ewbholdings.com/api';